/* eslint-disable import/prefer-default-export */
export const scrollToTopOrError = (erroringFieldIds = []) => {
  if (erroringFieldIds.length === 0) {
    window.scrollTo({ top: -20, behavior: 'smooth' });
    return;
  }

  const erroringFieldIdSelectors = erroringFieldIds.map((id) => `#${id}`);
  const errorElement = document.querySelector(erroringFieldIdSelectors.join(','));
  if (errorElement) {
    let viewportPadding = window.innerHeight * 0.12;
    const labelElement = document.querySelector(`label[for='${errorElement.id}']`);
    if (labelElement !== null) { // Scroll to label if it exists
      window.scrollTo({
        top: labelElement.getBoundingClientRect().top + window.scrollY - viewportPadding,
        behavior: 'smooth',
      });
    } else {
      if (window.innerWidth < 640) { // Adds extra padding for small screens
        viewportPadding += 20;
      }
      const rect = errorElement.getBoundingClientRect();
      const scrollTop = rect.top + window.pageYOffset - viewportPadding;
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }
  } else {
    window.scrollTo({ top: -20, behavior: 'smooth' });
  }
};

export const scrollToElement = (element, offset = 200) => {
  window.scrollTo({
    top: element.getBoundingClientRect().top + window.scrollY - offset,
    behavior: 'smooth',
  });
};
